import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHeart2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconHeart2"><Path d="M12.3674 21.404C21.0872 16.5047 23.0863 10.7671 21.5175 6.84578C20.7503 4.92821 19.1426 3.55922 17.2527 3.1368C15.5343 2.75271 13.6399 3.16312 12 4.54956C10.3601 3.16312 8.46574 2.75271 6.74731 3.13681C4.85744 3.55922 3.24973 4.92822 2.48258 6.8458C0.913781 10.7672 2.91292 16.5047 11.6327 21.404C11.8608 21.5322 12.1393 21.5322 12.3674 21.404Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHeart2;
